import axios from "axios";

const isDev = process.env.NODE_ENV == 'development'
const url = isDev ? "http://localhost:5555/api/stocks" : " https://client-web-api.thaisugars.com/api/stocks";

class StockService {

    // โหลด Stocks ** To be Delete
    static getStocks() {
        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(function (response) {
                    const data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

        // โหลดรายชื่อลูกค้าทั้งหมด
    static getCustomers() {
        return new Promise((resolve, reject) => {
            axios.get(url + '/customers')
                .then(function (response) {
                    const data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // โหลดสินค้าแนะนำสำหรับลูกค้ารายหนึ่ง (re-order reminders + cross-sell)
static getSuggestions(cuscod, limit = 20) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/customers/${encodeURIComponent(cuscod)}/suggestions?limit=${limit}`)
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    })
}

    // AI หารูปสินค้าจากเน็ต → คืน { query, images: [{url, thumbnail, source, width, height}] }
    static findProductImages(stkcod, name, page = 1) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/products/${encodeURIComponent(stkcod)}/find-images`, { params: { name, page } })
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // proxy ดึงรูปที่เลือกจาก url (ผ่าน backend เลี่ยง CORS) → คืน { success, image_data } เป็น base64
    static fetchFoundImage(stkcod, imageUrl) {
        return new Promise((resolve, reject) => {
            axios.post(`${url}/products/${encodeURIComponent(stkcod)}/use-found-image`, { url: imageUrl })
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // โหลดรายการสินค้าที่ลูกค้าเคยซื้อ (lazy — แยกจาก getCustomers เพื่อให้ list โหลดเร็ว)
    static getCustomerProducts(cuscod) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/customers/${encodeURIComponent(cuscod)}/products`)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // โหลดรายการบิล + สถานะการชำระเงินของลูกค้ารายหนึ่ง (6 เดือนล่าสุด)
    static getDebts(cuscod) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/customers/${encodeURIComponent(cuscod)}/debts`)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // โหลดรายละเอียดบิลใบเดียว (line items + ส่วนลด + VAT + รวมทั้งสิ้น)
    static getInvoice(docnum) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/invoices/${encodeURIComponent(docnum)}`)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // โหลดข้อมูลเสริมของลูกค้า (type/image/lat/lng/group)
    static getCustomerInfo(cuscod) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/customers/${encodeURIComponent(cuscod)}/info`)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // อัพเดทข้อมูลเสริมของลูกค้า (auto-create row ถ้ายังไม่มี + sync source fields จาก ARMAS)
    static saveCustomerInfo(cuscod, updates) {
        return new Promise((resolve, reject) => {
            axios.post(`${url}/customers/${encodeURIComponent(cuscod)}/info`, updates)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // โหลด context สำหรับ modal จัดกลุ่มร้านค้า (current group + used groups + same-amphoe peers)
    static getCustomerGroupContext(cuscod) {
        return new Promise((resolve, reject) => {
            axios.get(`${url}/customers/${encodeURIComponent(cuscod)}/group-context`)
                .then(res => resolve(res.data))
                .catch(err => reject(err))
        })
    }

    // Refresh Stocks
    static refreshStocks() {
        return new Promise((resolve, reject) => {
            axios.get(url + '/refresh')
                .then(function (response) {
                    const data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    static getImage(STKCOD) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${url}/getImage/${STKCOD}`)
                .then(function (response) {
                    const data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    // เพิ่ม หรือ แก้ไข _products_config
    static saveConfig(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/config', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    static saveImage(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/image', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // ลบรูปสินค้าออกจาก _products_images
    static deleteImage(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/DeleteImage', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    static saveNote(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/noted', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    static deleteNote(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/DeleteNote', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข _products_count_stocks SAVE MAKE ORDER
    static saveMakeOrder(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/saveMakeOrder', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข _products_count_stocks DELETE MAKE ORDER
    static deleteMakeOrder(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/DeleteMakeOrder', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข _products_count_stocks
    static saveStocksCount(index, data, data2 = null) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/stocksCount', { "index": index, "data": data, "data2": data2 })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข weight ทั้ง 3
    static saveStocksWeight(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/stocksWeight', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข _products_count_stocks
    static saveStocksCountLast(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/stocksCountLast', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // เพิ่ม หรือ แก้ไข _products_count_stocks
    static deleteStocksCount(index, data) {
        return new Promise((resolve, reject) => {
            axios.post(url + '/DeletestocksCount', { "index": index, "data": data })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

    // ค้นหาสินค้าจาก Makro API
    static searchMakro(q, limit = 20) {
        return new Promise((resolve, reject) => {
            if (!q?.trim()) {
                reject(new Error('Search query is required'));
                return;
            }
            axios.post(
                'https://search.maknet.siammakro.cloud/search/api/v1/indexes/products/search',
                { q: q.trim(), limit: limit },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Origin': 'https://www.makro.pro',
                    }
                }
            )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                })
        })
    }

}

export default StockService